import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierRatingsPanel from '../components/panels/CarrierRatingsPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierRatingsPage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'ratingPermission');

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {canView && (
        <>
          <StickyPageHeader
            subtitle={selectedCarrier.name}
            title="Ratings"
          />
          <CarrierRatingsPanel
            carrier={selectedCarrier}
            id="ratings"
            userRole={authUser?.role}
          />
        </>
      )}
    </Layout>
  );
};

export default CarrierRatingsPage;
